import PropTypes from "prop-types";

import React from "react";

// import { withRouter, matchPath } from "react-router";
// ^^ A Link element for our custom history router.

import CheckboxSet from "./CheckboxSet";
import FormRow from "./FormRow";
import SubmitButton from "./SubmitButton";
import TextField from "./TextField";
import UploadButton from "./UploadButton";




import "./style.scss";

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {},
      requiredFields: {},
      fieldTypes: {},
      errors: {},
      complete: false,
      submitted: false,
      // needsUpload: false,
    };

    this.vars = {
    };
  }

  componentDidMount() {

    this.init();
  };

  componentWillUnmount() {
  };

  componentDidUpdate(prevProps) {
    var Z = this;
  };

  init = () => {
    const Z = this;

    // Z.loadPage();
  };

  updateFormValue = (
    { fieldName, fieldValue, fieldType, fieldRequired },
    cb
  ) => {
    const Z = this;

    fieldRequired = fieldRequired || Z.state.requiredFields[fieldName];

    Z.setState(
      (state) => {
        state.values[fieldName] = fieldValue;
        state.fieldTypes[fieldName] = fieldType;
        if (fieldRequired != false && fieldRequired != null) {
          // Field is required!
          // console.log(fieldName, " --> Field is required!");
          state.requiredFields[fieldName] = fieldRequired;

          if (
            state.errors[fieldName] != null &&
            state.errors[fieldName] != false
          ) {
            // Field is currently marked with error (Red border)
            // console.log(fieldName, " --> Field currently has red error");
            if (fieldValue !== null && fieldValue !== "") {
              // console.log(fieldName, " --> Field has a value now!");
              // state.errors[fieldName] = Z.state.requiredFields[fieldName];
              state.errors[fieldName] = null;
            }
          }
        }
        return {
          values: state.values,
          requiredFields: state.requiredFields,
          errors: state.errors,
        };
      },
      () => {
        if (Z.props.onChange != null) {
          if (cb != null) cb();
          Z.props.onChange({ values: Z.state.values });
        }
      }
    );
  };

  validateForm = () => {
    const Z = this;

    var isComplete = true;
    var errors = {};

    for (var reqKey in Z.state.requiredFields) {
      if (
        Z.state.requiredFields[reqKey] != null &&
        Z.state.requiredFields[reqKey] != false
      ) {
        if (Z.state.values[reqKey] == null || Z.state.values[reqKey] == "") {
          // errors[reqKey] = "Please enter your..."; // Use this to pass specific messages instead of using the defaults.
          errors[reqKey] = Z.state.requiredFields[reqKey];
          isComplete = false;
        }
      }
    }

    Z.setState({
      errors: errors,
    });

    return isComplete;
  };

  render() {
    var Z = this;

    return (
      <form
        className={`Form ${Z.props.className || ""}`}
        style={Z.props.style || {}}
      >
        <div
          className={`form-errors ${
            Object.keys(Z.state.errors).length > 0 ? "active" : null
          }`}
        >
          Please complete all required fields.
        </div>
        {Z.props.children != null && Z.props.children.length > 0
          ? Z.props.children.map((child, childIndex) => {
              return React.Children.map(child, (subchild, subchildIndex) => {
                /* var extraProps = {};
                if (subchild.type == "SubmitButton") {
                  extraProps.fieldTypes = Z.state.fieldTypes
              } */

                let newSubchild = (
                  <subchild.type
                    key={`${childIndex}-${subchildIndex}`}
                    {...subchild.props}
                    formValues={Z.state.values}
                    formErrors={Z.state.errors}
                    fieldTypes={Z.state.fieldTypes}
                    updateFormValue={Z.updateFormValue}
                    validateForm={Z.validateForm}
                  >
                    {React.Children.map(
                      subchild.props.children,
                      (subsubchild, subsubchildIndex) => subsubchild
                    )}
                  </subchild.type>
                );
                return newSubchild;
              });
              // return (
              //   <child.type
              //     key={childIndex}
              //     {...child.props}
              //     formValues={Z.state.values}
              //     formErrors={Z.state.errors}
              //     updateFormValue={Z.updateFormValue}
              //     validateForm={Z.validateForm}
              //   >
              //     { React.Children.toArray(child.props.children) }
              //   </child.type>
              // );
              // return child;
            })
          : null}
      </form>
    );
  }
}

Form.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func,
};

export default Form;

export { FormRow, TextField, UploadButton, SubmitButton, CheckboxSet };
